import React, { HTMLAttributes, useCallback, useEffect, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import Storage from "utils/storage";

import { Dropdown, MenuProps } from "antd";
import XtSvg from "@/components/Xt/Svg";

import styles from "./index.module.scss";

import { OptionTradingViewProps, getOptionTradingView, ActionTradingViewProps } from "../../index";

interface Props extends HTMLAttributes<HTMLDivElement> {
  option: WithUndefined<OptionTradingViewProps>;
  setOption: (arg: OptionTradingViewProps) => void;
  setAction: (arg: ActionTradingViewProps) => void;
  isStandard?: boolean;
}

const Main: React.FC<Props> = ({ option, setOption, setAction, isStandard }) => {
  const t = useTranslation();

  const [optionAtvKey, setOptionAtvKey] = useState("");
  useEffect(() => {
    const { interval, chartType } = getOptionTradingView(option);
    const key = [interval, chartType].join("_");
    setOptionAtvKey(key);
  }, [option]);

  const handleClickOption = useCallback((interval: string, chartType = 1) => {
    const option = { interval, chartType };
    setOption(option);
    Storage.set("tvOption", option);
  }, []);
  const handleClickAction = useCallback(
    (actionId) => {
      setAction({ actionId });
      const { interval, chartType } = getOptionTradingView(option);
      if (chartType === 3 && actionId === "chartProperties") {
        setOption({ interval, chartType: 1 });
      }
    },
    [option]
  );

  const dropdownList = useMemo(() => {
    return [
      { key: "1_1", label: "1" + t("trade.klineMin") },
      { key: "3_1", label: "3" + t("trade.klineMin") },
      { key: "5_1", label: "5" + t("trade.klineMin") },
      { key: "30_1", label: "30" + t("trade.klineMin") },
      { key: "60_1", label: "1" + t("trade.klineHour") },
      { key: "120_1", label: "2" + t("trade.klineHour") },
      { key: "360_1", label: "6" + t("trade.klineHour") },
      { key: "480_1", label: "8" + t("trade.klineHour") },
      { key: "720_1", label: "12" + t("trade.klineHour") },
      { key: "3D_1", label: "3" + t("trade.klineDay") },
      { key: "1W_1", label: "1" + t("trade.klineWeek") },
      { key: "1M_1", label: "1" + t("trade.klineMonth") },
    ];
  }, []);
  const dropdownAtvDoc = useMemo(() => {
    return dropdownList.find((obj) => obj.key === optionAtvKey);
  }, [optionAtvKey, dropdownList]);
  const dropdownLabel = useMemo(() => {
    return dropdownAtvDoc ? dropdownAtvDoc.label : t("trade.more");
  }, [dropdownAtvDoc]);
  const dropdownItems: MenuProps["items"] = useMemo(() => {
    return dropdownList.map((obj) => {
      return {
        key: obj.key,
        label: <a onClick={() => handleClickOption(obj.key.split("_")[0])}>{obj.label}</a>,
      };
    });
  }, [dropdownList]);

  return (
    <div className={cx(styles.main, { [styles.standard]: isStandard })}>
      {/* 设计稿中展示的时间选择按钮 */}
      <button className={cx("btnTxt btnHover", { [styles.atv]: optionAtvKey === "1_3" })} onClick={() => handleClickOption("1", 3)}>
        {t("trade.klineTime")}
      </button>
      <button className={cx("btnTxt btnHover", { [styles.atv]: optionAtvKey === "15_1" })} onClick={() => handleClickOption("15")}>
        15{t("trade.klineMin")}
      </button>
      <button className={cx("btnTxt btnHover", { [styles.atv]: optionAtvKey === "240_1" })} onClick={() => handleClickOption("240")}>
        4{t("trade.klineHour")}
      </button>
      <button className={cx("btnTxt btnHover", { [styles.atv]: optionAtvKey === "1D_1" })} onClick={() => handleClickOption("1D")}>
        1{t("trade.klineDay")}
      </button>

      {/* 更多菜单 - 包含其他时间选项 */}
      <Dropdown
        placement={"bottomLeft"}
        menu={{
          items: dropdownItems,
          selectable: true,
          selectedKeys: dropdownAtvDoc ? [dropdownAtvDoc.key] : [],
        }}
      >
        <button className={cx("btnTxt btnHover btnDrop", styles.trigger, { [styles.atv]: !!dropdownAtvDoc })} onClick={(e) => e.preventDefault()}>
          {t("trade.more")}
          {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" className={styles.moreIcon}>
            <path d="M8 0L16 8L8 16L0 8L8 0Z" fill="#777e90" />
          </svg> */}
        </button>
      </Dropdown>
    </div>
  );
};

export default observer(Main);
